import React from 'react';
import { AbsoluteFill, useCurrentFrame, interpolate } from 'remotion';

// 数据可视化动画
export const DataVisualizationAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  
  const data = [
    { label: 'Jan', value: 65 },
    { label: 'Feb', value: 85 },
    { label: 'Mar', value: 120 },
    { label: 'Apr', value: 95 },
    { label: 'May', value: 140 },
  ];

  const maxValue = Math.max(...data.map(d => d.value));

  return (
    <AbsoluteFill style={{ background: '#0a0a23', padding: 80, color: 'white' }}>
      <h1 style={{ fontSize: 60, textAlign: 'center', marginBottom: 200 }}>
        数据可视化 📊
      </h1>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 60, height: 500 }}>
        {data.map((item, i) => {
          const height = interpolate(
            frame,
            [i * 20, i * 20 + 30],
            [0, (item.value / maxValue) * 400],
            { extrapolateRight: 'clamp' }
          );

          return (
            <div key={i} style={{ textAlign: 'center' }}>
              <div style={{
                width: 80,
                height: height,
                background: `linear-gradient(180deg, #667eea 0%, #764ba2 100%)`,
                borderRadius: 10,
                boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)',
              }} />
              <div style={{ marginTop: 20, fontSize: 32 }}>{item.label}</div>
              <div style={{ marginTop: 10, fontSize: 24, opacity: 0.7 }}>{item.value}</div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};
